import React, { useEffect, useState, useCallback } from 'react';
import { Button, Balloon } from '@alifd/next';
import styles from './index.module.scss';
import SelectGoods from '@/components/SelectGoods';

/**
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 */
const TagSku = ({
  changeData = (data) => {},
  tagItem = {},
  pageType = ''
}) => {
  const [data, setData] = useState(tagItem?.opValue?.param_list?.[0]?.param_id?.[0]); // radio选中的值
  // 选中的skuid
  const [skuIds, setSkuIds] = useState(tagItem?.opValue?.extra_map.length > 0 ? tagItem?.opValue?.extra_map.map(item => item) : []);
  // 选中的商品【其实应该和skuid一起做处理的，能用就行】
  const [selectGoods, setSelectGoods] = useState(tagItem?.opValue?.extra_map.length > 0 ? tagItem?.opValue?.extra_map.map(item => {return {skuId: item}}) : []);

  // 是否展示弹窗
  const [isShow, setIsShow] = useState(false);

  /**
   * 展示选择sku的弹窗
   */
  const showWdDialog = () => {
    setIsShow(true);
  };

  /**
   * 选择完毕关闭弹窗
   */
  const confirm = (v) => {
    setSkuIds(v);
    changeData({
      opValue: {
        label_id: tagItem.id,
        extra_map: v.map((item) => {
          return item.toString()
        })
      }, opType: 'ALL'
    });
    setIsShow(false);
  };


  /**
   * 选择时改变要处理成字符串形式传给父组件
   */
  // const changeValue = (val) => {
  //   setData(val);
  //   changeData({
  //     opValue: {
  //       label_id: tagItem.id,
  //       param_list: [
  //         {
  //           param_id: [val],
  //           sub_param_list: skuIds.map((item) => {
  //             return {
  //               param_str: item.toString()
  //             }
  //           })
  //         }
  //       ]
  //     },
  //     opType: 'ALL'
  //   });
  // };
  const tagNumbers = useCallback(() => {
    if (tagItem.opValue) {
      // 计算出tagItem.opValue.param_list中，二级类目的数量
      // const count = tagItem?.opValue?.param_list?.reduce((pre, cur) => {
      //   return pre + cur.sub_param_list.length;
      // }, 0);
      const count = tagItem?.opValue?.extra_map.length;
      // 如果二级类目的数量大于0，则显示“已选X个”，否则显示“已选0个”
      const selectedCount = count > 0 ? count : 0;
      return selectedCount;
    }
  }, [tagItem.opValue]);

  useEffect(() => {
    if( pageType==='1'|| (pageType ==='2' && !tagItem.opValue) ) { // 如果是创建
      changeData({
        opValue: {
          label_id: tagItem.id,
          extra_map: []
        }, opType: 'ALL'
      });
    }
  }, [pageType]);

  return (
    <div className={`${styles['tag-skus']} tag-width`}>
      <div className={styles['titleBox']}>
        <div>
          {tagItem.labelName}
          <Balloon.Tooltip
            align="t"
            closable={false}
            trigger={
              <span
                style={{
                  fontSize: '16px',
                  marginLeft: '4px',
                  cursor: 'pointer',
                }}
                className="iconfont icon-icon4-33"
              />
            }
          >
            <div>
              {tagItem.labelDescription}
            </div>
          </Balloon.Tooltip>
        </div>
        :
        <Button
          type='secondary'
          onClick={showWdDialog}
        >
          选择商品{tagNumbers() ?? 0}/300
        </Button>
      </div>
      <div style={{color:'#ff3333',padding:'2px 0 5px'}}>不选择商品，默认按照全店商品统计</div>
      {/* {
        skuIds.length <= 0 && <div style={{ color: "#f33" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelName}
        </div>
      } */}
      <SelectGoods
        goodsDialog={isShow}
        closeDialog={() => setIsShow(false)}
        skuIds={skuIds}
        confirmSkuid={(v) => confirm(v)}
        selectGoods={selectGoods}
        confirmGoods={(v) => {
          setSelectGoods(v);
        }}
        maxGoodsNum={300}
      />
    </div>
  );
};
export default TagSku;
